<template>
	<div id="aboutComponent">
		This is {{name}}.
		
	</div>


</template>
<script>
	export default {
		data(){
			return{
				name:"about"
			}
		}
	};

</script>
<style></style>


// WEBPACK FOOTER //
// ./src/views/about.vue